var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.548 19.5992C16.6044 19.5992 21.558 12.2115 21.558 5.80567C21.558 5.59537 21.558 5.38666 21.5436 5.17872C22.5072 4.49347 23.3388 3.64266 24 2.66915C23.1024 3.06139 22.1484 3.31863 21.1728 3.43204C22.2 2.82596 22.9692 1.87377 23.3376 0.750205C22.3704 1.31494 21.3132 1.7135 20.2104 1.92735C18.3456 -0.0244101 15.2268 -0.118974 13.2432 1.717C11.9652 2.90081 11.4216 4.66586 11.8188 6.34942C7.86 6.15331 4.1712 4.31264 1.6704 1.28458C0.3636 3.49979 1.032 6.33262 3.1956 7.75509C2.412 7.73264 1.6452 7.52493 0.96 7.14923V7.21075C0.9612 9.51814 2.6136 11.5049 4.9104 11.9621C4.1856 12.1571 3.4248 12.1853 2.688 12.0447C3.3324 14.0201 5.1816 15.3731 7.2876 15.4121C5.544 16.7613 3.39 17.494 1.1724 17.4916C0.7812 17.4904 0.39 17.468 0 17.4219C2.2524 18.8444 4.872 19.5993 7.548 19.5957",
    fill: "#1DA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.55e8d957d2a398f09f34887dc00b4e7c.svg";
export { ForwardRef as ReactComponent };